module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable56.575b12fe.jpg";